// 共通模块:  admin选中的工厂名。

// hongmj: 这里放全局参数
const state = {
    factory: ''
}

// hongmj: 这里是set方法
const mutations = {
    // 保存 某个模块 选中的分页
    SAVE_FACTORY: (state, factoryName) => {
        state.factory = factoryName
    }

}

// hongmj: 这部分暂时用不上
const actions = {
}

// hongmj: 下面不清楚做啥的，好像都有?
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
